const getMobileDeviceInfo = (userAgent = window.navigator.userAgent) => {
  const isIOS = /iPhone|iPod/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1); // iPadOS 13+ reports as Mac
  const isAndroid = /Android/i.test(userAgent);
  const isTablet = /iPad/i.test(userAgent) ||
    (isAndroid && !/Mobile/i.test(userAgent)) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1);

  return {
    isIOS,
    isAndroid,
    isTablet,
    isMobile: (isIOS || isAndroid) && !isTablet
  };
};

export default getMobileDeviceInfo;
